import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import ExtendCCSvg from 'ext-ui/svg/illustration/ExtendCCSvg'
import React, { ComponentProps, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslate } from 'src/localization/Trns'
import { selectAstradaVerifyUrlFromState } from 'src/redux/selectors/session.selectors'

export type Confirm3DSVerificationeProps = {
  className?: string
  verificationId: string
  iframeProps?: ComponentProps<'iframe'>
  isRetry?: boolean
}

export default function Confirm3DSVerification(
  props: Confirm3DSVerificationeProps,
) {
  const {
    className = '',
    verificationId,
    iframeProps = {},
    isRetry = false,
  } = props
  const astrada3dsVerifyBaseUrl = useSelector(selectAstradaVerifyUrlFromState)
  const [startVerification, setStartVerification] = useState<boolean>(isRetry)

  const translate = useTranslate()

  const handleClickContinue = () => {
    setStartVerification(true)
  }

  return (
    <div className={cn('Confirm3DSVerification', className)}>
      {startVerification ? (
        // Show the iframe with OTP authentication messaging
        <div className="flex-column align-center justify-center gap-10">
          <div className="flex-column align-center justify-center gap-5">
            <p className="font-h2">
              {translate(
                'For your security, we need you to authenticate with your bank',
              )}
            </p>
            <p className="font-regular">
              {translate(
                'Your bank may ask you to enter a one-time password (OTP) to verify your identity. In some cases it may result in a temporary authentication charge which will be subsequently refunded.',
              )}
            </p>
          </div>
          <iframe
            height={600}
            width="100%"
            src={`${astrada3dsVerifyBaseUrl}?v=${verificationId}`}
            title="3dsVerify"
            {...iframeProps}
          />
        </div>
      ) : (
        // Show a confirmation screen to alert the user we are going to start the process.
        <div className="flex-column align-center justify-center gap-10">
          {/* Illustration */}
          <div className="flex-column align-center justify-center">
            <ExtendCCSvg />
          </div>
          {/* Title and text block */}
          <div className="flex-column align-center justify-center gap-3">
            <p className="font-h3">{`🎉 ${translate('Almost Done!')} 🎉`}</p>
            <p className="font-regular">
              {translate(
                'One final step as we complete cardholder verification with your bank',
              )}
            </p>
          </div>
          {/* Button */}
          <Button onClick={handleClickContinue}>{translate('Continue')}</Button>
        </div>
      )}
    </div>
  )
}
